import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Select from "react-select";
import SuperSelect from "../../Misc/SuperSelect";
import OutsideInput from "../../Misc/Outside/OutsideInput";
import ModelInfo from "../Product/ModelInfo";

export default class ModelDetailDefault extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      types: [],
      category: [],
      vendor: [],
      notFound: false,
      pending: false,
      info: false,
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.modelId !== this.props.modelId) {
      this.load();
    }
  }

  openModelInfo = () => {
    this.setState({ info: true });
  };
  closeModelInfo = () => {
    this.setState({ info: false });
  };

  save = async () => {
    const { item } = this.state;

    let category = item.category;
    if (!category || category === "any") {
      category = null;
    }
    this.setState({ pending: true });

    let reset = item.id === "add" ? null : this.context.api.nullUuid;

    let result = await this.context.api.q("/model/set", {
      id: item.id === "add" ? null : item.id,
      name: item.name,
      code: item.code,
      subcode: item.subcode,
      type: this.context.getType(item.typecode),
      description: item.description,
      vendor: item.vendor,
      country: item.country,
      measure: item.measure || reset,
      main: item.main ? true : false,
      mincount: item.mincount || 0,
      maxcount: item.maxcount || 0,
      category,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");
      if (this.props.modelId === "add") {
        if (this.props.onAfterAdd) {
          this.props.onAfterAdd(result);
        }
      } else {
        if (this.props.onAfterSave) {
          this.props.onAfterSave(item);
        }
      }
      this.load();
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  loadReferences = async () => {
    this.setState({ pending: true });

    let types = [];
    let typesQuery = await this.context.api.qa("/model/type", {});
    if (Array.isArray(typesQuery)) {
      typesQuery.forEach((item) => {
        types.push({
          value: item.code,
          label: item.name,
        });
      });
    }

    let category = [];
    let categoryQuery = await this.context.api.qa("/category/list", {
      search: [
        {
          field: "typecode",
          compare: "EQL",
          value: "item.category",
        },
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(categoryQuery)) {
      categoryQuery.forEach((item) => {
        category.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    let vendor = [];
    let vendorQuery = await this.context.api.qa("/vendor/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(vendorQuery)) {
      vendorQuery.forEach((item) => {
        vendor.push({
          value: item.id,
          label: item.label,
        });
      });
    }
    this.setState({ types, vendor, category, pending: false });
  };

  load = async () => {
    this.setState({ pending: true });
    let itemQuery = {};
    if (this.props.modelId !== "add") {
      itemQuery = await this.context.api.q("/model/get", {
        id: this.props.modelId,
      });
    } else {
      itemQuery = {
        id: "add",
        category: this.props.categoryId,
      };
    }

    this.setState({
      pending: false,
      item: itemQuery || {},
      notFound: itemQuery === false,
    });
  };

  cartAdd = async () => {
    const { modelId } = this.props;
    if (modelId && modelId !== "add") {
      this.setState({ pending: true });
      let result = await this.context.cart.addItem(modelId);
      if (result === false) {
        this.context.toast("Не удалось добавить в подборку", "error");
      } else {
        this.context.toast("Добавлено в подборку", "success");
      }
      this.context.force();
      this.setState({ pending: false });
    }
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onMethodFinish = () => {
    if (this.props.onAfterSave) {
      this.props.onAfterSave(this.state.item);
    }
    this.load();
  };

  handleCreateVendor = async (value) => {
    if (value) {
      this.setState({ pending: true });
      let result = await this.context.api.q("/vendor/set", {
        name: value,
      });
      if (result) {
        this.onChange("vendor", result.id);
        await this.loadReferences();
      } else {
        this.context.toast("Не удалось добавить производителя", "error");
      }
    }
  };

  render() {
    const { notFound, pending, item } = this.state;
    const { manageModel } = this.props;
    return (
      <>
        <Blocker hAuto spinnerFixed on={pending}>
          {notFound && <DefaultNotFound />}
          {item.id && (
            <>
              <div className=" d-flex justify-content-end align-items-center">
                {item.id !== "add" && (
                  <>
                    <EssenceStateLabel
                      stateCode={item.statetypecode}
                      stateLabel={item.statelabel}
                      essence="manual"
                      id={item.id}
                    />
                    <EssenceActionsDropdown
                      essence={"manual"}
                      key={item.id}
                      id={item.id}
                      label={item.label}
                      onFinish={this.onMethodFinish}
                    />
                  </>
                )}
              </div>

              <div className="pb-3"></div>
              <div className="row">
                <div className="form-group col-lg-12">
                  <label>Наименование:</label>
                  <input
                    className="form-control"
                    type="text"
                    value={item.name || ""}
                    onChange={(e) => this.onChange("name", e.target.value)}
                  />
                </div>

                <div className="form-group col-lg-6">
                  <label>Тип:</label>
                  <Select
                    value={this.getReferenceValue(
                      item.typecode,
                      this.state.types
                    )}
                    onChange={(result) =>
                      this.onChange("typecode", result.value)
                    }
                    className="from-control react-select"
                    classNamePrefix="react-select-inner"
                    options={this.state.types}
                    placeholder="Выберите тип..."
                    noOptionsMessage={({ inputValue }) =>
                      `Ничего не найдено по запросу ${inputValue}`
                    }
                  />
                </div>
                <div className="form-group  col-lg-6">
                  <label>Категория:</label>
                  <SuperSelect
                    add
                    defaultValue={item.category}
                    onChange={(value) => this.onChange("category", value)}
                    essence="category"
                    placeholder="Выберите категорию..."
                    nameField="name"
                    idField="id"
                    type="item.category"
                    reference={{
                      essence: "category",
                      sort: "sequence",
                      title: "Категория",
                      showDescription: true,
                      forceType: "item.category",
                    }}
                  />
                </div>
                <div className="form-group col-lg-6">
                  <label>Код:</label>
                  <input
                    className="form-control"
                    type="text"
                    value={item.code || ""}
                    onChange={(e) => this.onChange("code", e.target.value)}
                  />
                </div>
                <div className="form-group col-lg-6">
                  <label>Специальный код:</label>
                  <OutsideInput
                    pickField="code"
                    source="model.subcode"
                    value={item.subcode || ""}
                    onChange={(v) => this.onChange("subcode", v)}
                  />
                </div>

                <div className="form-group  col-lg-12">
                  <label>Производитель:</label>
                  <SuperSelect
                    add
                    isClearable
                    defaultValue={item.vendor}
                    onChange={(value) => this.onChange("vendor", value)}
                    essence="vendor"
                    placeholder="Выберите производителя..."
                    nameField="name"
                    idField="id"
                    reference={{
                      essence: "vendor",
                      sort: "sequence",
                      title: "Производитель",
                      showDescription: true,
                    }}
                  />
                </div>
                <div className="form-group  col-lg-6">
                  <label>Единица измерения:</label>
                  <SuperSelect
                    add
                    isClearable
                    defaultValue={item.measure}
                    onChange={(value) => this.onChange("measure", value)}
                    essence="measure"
                    placeholder="Выберите..."
                    nameField="name"
                    idField="id"
                    reference={{
                      title: "Единицы измерения",
                      essence: "measure",
                      showDescription: true,
                      showType: true,
                    }}
                  />
                </div>
                <div className="form-group  col-lg-6">
                  <label>Страна:</label>
                  <SuperSelect
                    add
                    isClearable
                    defaultValue={item.country}
                    onChange={(value) => this.onChange("country", value)}
                    essence="country"
                    placeholder="Выберите страну..."
                    nameField="name"
                    idField="id"
                    isClearable
                    reference={{
                      essence: "country",
                      sort: "sequence",
                      title: "Страны",
                      showDescription: true,
                    }}
                  />
                </div>
                <div className="form-group col-lg-6">
                  <label>Минимальный заказ:</label>
                  <input
                    className="form-control"
                    type="number"
                    value={item.mincount || ""}
                    onChange={(e) => this.onChange("mincount", e.target.value)}
                  />
                </div>
                <div className="form-group col-lg-6">
                  <label>Максимальный заказ:</label>
                  <input
                    className="form-control"
                    type="number"
                    value={item.maxcount || ""}
                    onChange={(e) => this.onChange("maxcount", e.target.value)}
                  />
                </div>
                <div className="form-group  col-lg-12">
                  <label>Описание:</label>
                  <input
                    className="form-control"
                    type="text"
                    value={item.description || ""}
                    onChange={(e) =>
                      this.onChange("description", e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="form-group mt-3">
                <label className="checkbox">
                  <input
                    type="checkbox"
                    id="main"
                    onChange={(e) => this.onChange("main", e.target.checked)}
                    checked={item.main}
                  />
                  <span className="mr-2"></span>
                  Является основным средством
                </label>
              </div>

              <div className="mb-4 py-2 border-bottom"></div>
              {manageModel && (
                <button onClick={this.save} className="btn btn-primary mr-2">
                  Сохранить
                </button>
              )}
              {item.id !== "add" && (
                <>
                  <button
                    onClick={this.cartAdd}
                    className="btn btn-icon btn-light mr-2"
                    title="Добавить в подборку"
                  >
                    <i className="fa fa-cart-plus"></i>
                  </button>
                  <button
                    onClick={this.openModelInfo}
                    className="btn btn-icon btn-light mr-2"
                    title="Информация о модели"
                  >
                    <i className="fa fa-info"></i>
                  </button>
                </>
              )}
              {this.state.info && (
                <ModelInfo
                  id={item.id}
                  label={item.label}
                  description={item.description}
                  onHide={this.closeModelInfo}
                />
              )}
            </>
          )}
        </Blocker>
      </>
    );
  }
}
